// @flow
import axios from 'lib/defaultClient';

export const like = (brandId: string) => axios.post(`/brands/${brandId}/like`);

export const unlike = (brandId: string) => axios.delete(`/brands/${brandId}/like`);

export const getLikesCount = (brandId: string) => axios.get(`/brands/${brandId}/like`);



// WEBPACK FOOTER //
// ./src/lib/api/brands/like.js